import { isNullOrUndefined } from 'tr-lib';

export const dashboardFilter = (filterKey: string, currentProgress: string, additionalCondition?: boolean): boolean => {
  const [shortStatus] = currentProgress.split(':');

  return isNullOrUndefined(filterKey) || shortStatus === filterKey || (filterKey === 'Closed' && additionalCondition);
}
